interface RecoveryNoticeProps {
  kind: "recovered" | "corrupt";
}

export function RecoveryNotice({ kind }: RecoveryNoticeProps) {
  return (
    <div className={`recovery-notice recovery-notice--${kind}`} role="alert">
      {kind === "recovered"
        ? "We restored your previous good save. Press Save to make it the newest copy."
        : "We couldn’t restore this drawing. Your project details are safe, and the stored copies were not changed."}
    </div>
  );
}
